// extracted by mini-css-extract-plugin
export var arrow = "_ld-1";
export var content = "_ld-0";
export var highlighted = "_ld-2";